/**
 * アクション
 * componentから呼ばれる
*/

//アクションタイプからimport
import {
    JYUAT001_ADD,
    JYUAT001_DEL,
    JYUAT001_UPD,
    JYUAT001_GET,
    GET_KBN
} from "../types";

//サーバ側のサービスimport
import pocService from "../../services/pocs";
import rootScope from "../../store/rootScopeStore";
import { showDialog } from "../../util/util";

//チュートリアル登録処理
export const addJyuchuInf = (inputdata) => async (dispatch) => {
    try {
        //サーバ側のサービスの非同期呼び出し、引数に登録内容
        const res = await pocService.create({
            ...inputdata
        });

        //state変更のためにreducersに渡す
        dispatch({
            type: JYUAT001_ADD,
            payload: res.data,
        });

        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const retrieveJyuchuinf = () => async (dispatch) => {
    try {
        const res = await pocService.getAll();

        dispatch({
            type: JYUAT001_GET,
            payload: res.data,
        });
    } catch (err) {
        console.log(err);
    }
};

export const updateJyuchuinf = (id, data) => async (dispatch) => {
    try {
        const res = await pocService.update(id, data);

        dispatch({
            type: JYUAT001_UPD,
            payload: data,
        });

        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const deleteTutorial = (id) => async (dispatch) => {
    try {
        await pocService.remove(id);

        dispatch({
            type: JYUAT001_DEL,
            payload: { id },
        });
    } catch (err) {
        console.log(err);
    }
};

export const getDataById = (id) => async (dispatch) => {
    try {
        const res = await pocService.findById(id);

        dispatch({
            type: JYUAT001_GET,
            payload: res.data,
        });


    } catch (err) {
        console.log(err);
    }
};

export const retrieveKbn = () => async () => {
    showDialog();
    return new Promise(async (resolve, reject) => {
        try {
            const res = await pocService.getKubunmap();
            const resKbn = await pocService.getKubunmaplist();
            if (res) rootScope.kbn = JSON.parse(res.data.data);
            if (resKbn) rootScope.kbnList = JSON.parse(resKbn.data.data);
            showDialog("off");
            return resolve(res);
        } catch (err) {
            console.log(err);
            showDialog("off");
            return reject(err);
        }

    })
};

export const retrieveMessage = () => async () => {
    showDialog();
    return new Promise(async (resolve, reject) => {
        try {
            const res = await pocService.getMessagemap();
            if (res) rootScope.Message = JSON.parse(res.data.data);
            showDialog("off");
            return resolve(res);
        } catch (err) {
            console.log(err);
            showDialog("off");
            return reject(err);
        }

    })
};

export const retrieveTni = () => async () => {
    showDialog();
    return new Promise(async (resolve, reject) => {
        try {
            const res = await pocService.getTniList();
            if (res) rootScope.tniList = res.data.data;
            showDialog("off");
            return resolve(res);
        } catch (err) {
            console.log(err);
            showDialog("off");
            return reject(err);
        }

    })
};
